import { createFileRoute } from "@tanstack/react-router"
import { BackofficeBi } from "modules/backoffice/components/bi"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { TimeDimensionSchema, TimeFrameEnum, TimeFrameSchema } from "schema"
import { z } from "zod"

const SearchSchema = z.object({
  companyId: z.string().optional(),
  timeFrame: TimeFrameSchema.default(TimeFrameEnum.LastMonth),
  timeDimension: TimeDimensionSchema.optional(),
})

export const Route = createFileRoute("/_base/_auth/backoffice/bi")({
  component: BackofficeBi,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => {
    return SearchSchema.parse(search)
  },
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.bi.title"),
    })
  },
})
